import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookmarkKnowOverlayComponent } from './bookmark-know-overlay.component';

@NgModule({
  imports: [CommonModule, BookmarkKnowOverlayComponent],
  exports: [BookmarkKnowOverlayComponent],
})
export class BookmarkOverlayModule {}
